module.exports = __webpack_public_path__ + "static/media/SMSF.79839073.jpg";